<template>
    <table class="ReportDataRow" :class="{ 'no-border': !showBorder }">
        <tr v-if="title">
            <td :colspan="maxColumns">{{ title }}</td>
        </tr>
        <tr v-for="(row, rowIndex) in dataRows" :key="rowIndex">
            <td v-for="(item, colIndex) in row" :key="colIndex">{{ item }}</td>
        </tr>
    </table>
</template>

<script>
export default {
    name: 'ReportDataRow',
    props: {
        title: { type: String, default: '' },
        dataRows: { 
            type: Array, 
            required: true, 
            validator(value) {
                return value.every(row => Array.isArray(row) && row.length > 0);
            }
        },
        showBorder: { type: Boolean, default: false }
    },
    computed: {
        maxColumns() {
            return Math.max(...this.dataRows.map(row => row.length), 1);
        }
    }
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ReportDataRow {
    height: 100%;
    border-collapse: collapse;

    tr td {
        padding: 2px;
    }

    &.no-border {
        tr td:first-child {
            border-left: none;
        }
        tr td:last-child {
            border-right: none;
        }
        tr:first-child td {
            border-top: none;
        }
        tr:last-child td {
            border-bottom: none;
        }
    }
}
</style>
